import { useUserInfo } from "@/api/user";
import { config } from "@/config";
import { shouldRecordReplay } from "@/integrations/replayGate";
import Sentry from "@/integrations/Sentry";
import { trackSessionStart } from "@/utils/analytics";
import { useEffect, useRef } from "react";

// Mixpanel identity lives in AnalyticsIdentitySync; this keeps GTM + Sentry.
export function useTrackUser() {
  const { data: userInfo } = useUserInfo();
  const hasTrackedSessionStart = useRef(false);
  const hasStartedReplay = useRef(false);

  useEffect(() => {
    if (userInfo) {
      // Track session start only once
      if (!hasTrackedSessionStart.current) {
        trackSessionStart({ userId: userInfo.user.id });
        hasTrackedSessionStart.current = true;
      }

      Sentry.setUser({
        email: userInfo.user.email,
        id: userInfo.user.id,
        organization_id: userInfo.organization?.id,
        organization: userInfo.organization?.name,
      });

      Sentry.setTags({
        user_id: userInfo.user.id,
        user_name: userInfo.user.name,
        user_email: userInfo.user.email,
        organization_id: userInfo.organization?.id,
        organization_name: userInfo.organization?.name,
      });

      if (
        !hasStartedReplay.current &&
        shouldRecordReplay({
          enabled: config.sentry.enabled,
          environment: config.sentry.environment,
          email: userInfo.user.email,
          webdriver: navigator.webdriver,
          pathname: window.location.pathname,
        })
      ) {
        hasStartedReplay.current = true;
        try {
          Sentry.getReplay()?.start();
        } catch {
          // already recording
        }
      }
    }
  }, [userInfo]);
}
